import { useNavigate, useLocation } from 'react-router-dom';

const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const footerItems = [
    { label: "About", href: "/about" },
    { label: "Terms", href: "/policy", tab: "terms" },
    { label: "Privacy", href: "/policy", tab: "privacy" },
    { label: "Cookies", href: "/policy", tab: "cookies" },
  ];

  const handleClick = (e, item) => {
    e.preventDefault();
    if (item.tab) {
      navigate(item.href, {
        state: { activeTab: item.tab, from: location.pathname }
      });
    } else {
      navigate(item.href);
    }
  };

  return (
    <footer className="bg-white py-4 md:py-6 px-4 md:px-20 flex-shrink-0">
      <div className="flex justify-center items-center flex-wrap gap-x-3 gap-y-2 md:gap-x-6 mb-4">
        {footerItems.map((item) => (
          <a
            key={item.label}
            href={item.href}
            onClick={(e) => handleClick(e, item)}
            className="text-sm text-gray-600 hover:text-gray-900 transition-colors"
          >
            {item.label}
          </a>
        ))}
      </div>
      <div className="text-center">
        <p className="text-xs text-gray-500">
          © 2026 Wryven. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;